import { render, staticRenderFns } from "./Word.vue?vue&type=template&id=269fa130&scoped=true&"
import script from "./Word.vue?vue&type=script&lang=js&"
export * from "./Word.vue?vue&type=script&lang=js&"
import style0 from "./Word.vue?vue&type=style&index=0&id=269fa130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269fa130",
  null
  
)

export default component.exports